import { Injectable } from "@angular/core";
import { WidgetInstance } from "friendly-challenge";

@Injectable({
  providedIn: 'root'
})
export class FriendlycaptchaService {
  createWidget(element: HTMLElement, doneCallback: (solution: string) => void = (): void => { }, errorCallback: (error: any) => void = (): void => { }): WidgetInstanceMock {
    doneCallback('1.2.3');
    return new WidgetInstanceMock(document.createElement('div'));
  };
}

export class WidgetInstanceMock extends WidgetInstance {
  init(): void { };

  start(): Promise<void> {
    return new Promise<void>(resolve => {      
      resolve();
    });
  };
}
